import React, {
  createContext,
  useContext,
  useState,
  useCallback,
} from "react";

const RecipientListContext = createContext();

export const useRecipientList = () => {
  const context = useContext(RecipientListContext);
  if (!context) {
    throw new Error(
      "useRecipientList must be used within a RecipientListProvider"
    );
  }
  return context;
};

export const RecipientListProvider = ({ children }) => {
  const [cache, setCache] = useState({ recipients: null, allowAnyArtist: null });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getRecipients = useCallback(async (allowAnyArtist = false) => {
    const normalized = allowAnyArtist === true || allowAnyArtist === "true";
    if (cache.recipients !== null && cache.allowAnyArtist === normalized) {
      return { success: true, recipients: cache.recipients };
    }

    try {
      setLoading(true);
      setError(null);
      const url = normalized
        ? "/api/messaging/recipients?allowAnyArtist=true"
        : "/api/messaging/recipients";
      const response = await fetch(url, {
        credentials: "include",
      });
      const data = await response.json();

      if (data.success) {
        setCache({ recipients: data.recipients || [], allowAnyArtist: normalized });
        return data;
      }

      setError(data.error || "Failed to load recipients");
      return data;
    } catch (err) {
      console.error("Error fetching recipients:", err);
      setError(err.message || "Failed to load recipients");
      return {
        success: false,
        error: err.message || "Failed to load recipients",
      };
    } finally {
      setLoading(false);
    }
  }, [cache.recipients, cache.allowAnyArtist]);

  const value = {
    recipients: cache.recipients,
    loading,
    error,
    getRecipients,
  };

  return (
    <RecipientListContext.Provider value={value}>
      {children}
    </RecipientListContext.Provider>
  );
};
